import { createReducer } from '@mews/framework/redux';

const initialState = {};

export const globalization = createReducer(initialState, {});
